import React from 'react';
import MainSection from "./view/MainSection";
import SystemResource from "../../../service/SystemResource";

class MainSectionContainer extends React.Component {

    constructor(props) {
        super(props);

        // set initial values as you like (maybe really not to 0 if stats service fail?
        this.state = {
            statisticData : {
                userCount: 0,
                moduleCount: 0,
                exerciseCount: 0,
                teachingDurationInHours: 0
            }
        }
    }

    loadStatistics = () => {
        SystemResource.stats().then(
            (response) => {
                this.setState({
                    ...this.state,
                    statisticData : {
                        userCount: response.userCount,
                        moduleCount: response.moduleCount,
                        exerciseCount: response.exerciseCount,
                        teachingDurationInHours: response.teachingDurationInHours
                    }
                });
            }
        )
    };

    componentDidMount() {
        this.loadStatistics();
    }

    render() {
        return (
            <MainSection onOrder = {this.props.onOrder} statisticData = {this.state.statisticData}/>
        );
    }
}


export default MainSectionContainer;


// WEBPACK FOOTER //
// ./src/components/company/section/MainSectionContainer.jsx